import { useFieldArray, useFormContext } from "react-hook-form";
import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";

interface EmailListInputProps {
  name: string;
  label: string;
  description?: string;
  placeholder?: string;
}

export function EmailListInput({ name, label, description, placeholder = "Enter email" }: EmailListInputProps) {
  const { control, register } = useFormContext();

  const { fields, append, remove } = useFieldArray({ control, name });

  const addRow = () => append("");

  return (
    <div className="flex flex-col gap-2 p-2">
      <FormLabel>{label}</FormLabel>
      {description && <FormDescription>{description}</FormDescription>}

      {fields.map((field, index) => (
        <FormField
          key={field.id}
          control={control}
          name={`${name}.${index}` as const}
          render={() => (
            <FormItem className="flex items-center gap-2">
              <Input
                {...register(`${name}.${index}`, {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Invalid email",
                  },
                })}
                placeholder={placeholder}
                className="flex-1"
              />
              <Button type="button" size="icon" variant="outline" onClick={() => remove(index)}>
                <X className="h-4 w-4" />
              </Button>
              <FormMessage />
            </FormItem>
          )}
        />
      ))}

      <Button type="button" size="sm" variant="outline" onClick={addRow}>
        <Plus className="mr-1 h-4 w-4" /> Add
      </Button>
    </div>
  );
}
